import React, { Fragment, useCallback } from 'react';
import updateIcon from '../../img/ico_update.png';
import updateIcon2X from '../../img/ico_update@2x.png';
import updateNewIcon from '../../img/ico_new.png';
import updateNewIcon2X from '../../img/ico_new@2x.png';
import iconSpinner from '../../img/spinner.gif';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { cssClearFix, cssFloatLeft, cssFloatRight } from '../common/CssCommon';
import { LANGUAGE, NOTIFICATION_UPDATE_LIST_COUNT } from '../../define/global';
import { getLanguage } from '../../utils/util';
import { useGetNotification } from '../../hooks/getNotificationHook';

const UpdateHeader = styled.div`
  width: 100%;
  height: 28px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 4px;
  margin-bottom: 8px;
`;

const UpdateHeaderIcon = styled.img`
  width: 24px;
  height: 24px;
`;
const UpdateHeaderTitle = styled.span`
  margin-left: 7px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

const UpdateListWraaper = styled.ul`
  width: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const UpdateListItem = styled.li`
  ${cssClearFix}
  display: flex;
  overflow: hidden;
  //height: 20px;
`;

const UpdateListItemContentWrapper = styled.div`
  ${cssFloatLeft}
  flex: 1;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

const UpdateListItemContent = styled.a`
  text-decoration: none;
  max-width: 350px;
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.77;
  letter-spacing: normal;
  color: #2f3133;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const UpdateErrorMessage = styled.div`
  width: 100%;
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.77;
  letter-spacing: normal;
  color: #2f3133;
  overflow: hidden;
  text-align: center;
`;

const UpdateListItemNew = styled.img`
  width: 15px;
  height: 15px;
  margin-left: 4px;
`;

const UpdateListItemDate = styled.span`
  ${cssFloatRight}
  width: 100px;
  float: right;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.77;
  letter-spacing: normal;
  text-align: right;
  color: #2f3133;
`;

const UpdateListSpinnerWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const UpdateListSpinner = styled.img`
  width: 32px;
  height: 32px;
`;

export default function UpdateNotification() {
  const { t, i18n } = useTranslation();
  const supportLang = [LANGUAGE.EN, LANGUAGE.KO];
  let requestLang = LANGUAGE.EN;
  const langByi18n = getLanguage(i18n.language);
  if (supportLang.includes(langByi18n)) {
    requestLang = langByi18n;
  }

  const { data, complete, error, reload } = useGetNotification(
    NOTIFICATION_UPDATE_LIST_COUNT,
    requestLang
  );

  const updateNotification = () => {
    try {
      const contentsArr = data.notice.map((content) => (
        <UpdateListItem key={content.id}>
          <UpdateListItemContentWrapper>
            <UpdateListItemContent href={content.link} target="_blank" rel="noopener noreferrer">
              {content.title}
            </UpdateListItemContent>
            {content.newBadge && <UpdateListItemNew src={updateNewIcon} srcSet={updateNewIcon2X} />}
          </UpdateListItemContentWrapper>
          <UpdateListItemDate>{content.date}</UpdateListItemDate>
        </UpdateListItem>
      ));
      return contentsArr;
    } catch (err) {
      //TODO Error Handling
    }
  };

  return (
    <Fragment>
      <UpdateHeader>
        <UpdateHeaderIcon src={updateIcon} srcSet={updateIcon2X} onClick={reload} />
        <UpdateHeaderTitle>{t('FileMenu.UpdateHeaderTitle')}</UpdateHeaderTitle>
      </UpdateHeader>
      {complete && data && <UpdateListWraaper>{updateNotification()}</UpdateListWraaper>}
      {complete && error && (
        <UpdateErrorMessage>{t('FileMenu.NotificationLoadFail')}</UpdateErrorMessage>
      )}
      {complete === false && (
        <UpdateListSpinnerWrapper>
          <UpdateListSpinner src={iconSpinner} />
        </UpdateListSpinnerWrapper>
      )}
    </Fragment>
  );
}
